import axios from 'axios';
// import { getCookie } from '@/utils'
export const dataProcessingMethods = {
  methods: {
     // 获取Cookie值的通用方法
    //  getCookie(name) {
    //   let cookieValue = null;
    //   if (document.cookie && document.cookie !== '') {
    //     const cookies = document.cookie.split(';');
    //     for (let i = 0; i < cookies.length; i++) {
    //       const cookie = cookies[i].trim();
    //       // 检查cookie是否以目标名称开头
    //       if (cookie.substring(0, name.length + 1) === (name + '=')) {
    //         cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
    //         break;
    //       }
    //     }
    //   }
    //   return cookieValue;
    // },

    // 多表学校名更改
    async updateSchoolNames() {
      try {
        this.isLoading = true;
        this.$message.info('正在执行多表学校名更改操作，后端处理中...');
        
        // 获取csrftoken
        // const csrftoken = getCookie('csrftoken');
        
        // 发送请求到后端API，在headers中添加csrftoken
        const response = await axios.post('api/updateSchoolNames/', {}, {
          // withCredentials: true,  // 启用Cookie传递
          //   headers: {
          //       'X-Csrftoken': csrftoken
          //   },
          //   credentials: 'include',  // 确保发送cookie
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        });
        
        // 处理响应结果
        if (response.data && response.data.status === 'success') {
            this.$message.success(`多表学校名更改操作成功：${response.data.message}`);
        } else {
            this.$message.error('多表学校名更改操作失败: ' + (response.data?.message || '未知错误'));
        }
    } catch (error) {
        console.error('发送多表学校名更改命令失败:', error);
        this.$message.error('发送多表学校名更改命令失败，请稍后重试');
    } finally {
        this.isLoading = false;
    }
},
    // 获取原始数据中的年份最大值
    async fetchMaxDataYear() {
      console.log('fetchMaxDataYear 开始执行')
      try {
        const response = await axios.get('api/fetch-max-data-year/');
        console.log('fetchMaxDataYear 响应:', response.data)
        if (response.data.success) {
          this.maxDataYear = response.data.max_year;
          // 设置默认值为最大值+1
          this.formData.admit_year = this.maxDataYear + 1;
          console.log('设置 admit_year:', this.formData.admit_year)
        } else {
          console.error('fetchMaxDataYear 返回失败:', response.data)
          // 提示用户刷新
          this.$message.warning('数据加载失败，请刷新页面重试')
        }
      } catch (error) {
        console.error('获取最大年份失败:', error);
        // 输出详细错误信息
        if (error.response) {
          console.error('后端返回错误状态:', error.response.status, error.response.data);
        } else if (error.request) {
          console.error('请求已发送但无响应，后端可能未运行');
        } else {
          console.error('请求配置错误:', error.message);
        }
        // 出错时使用当前年份作为默认值（高考报考年份）
        this.formData.admit_year = new Date().getFullYear();
        console.log('出错，使用当前年份:', this.formData.admit_year)
        this.$message.warning('网络异常，使用默认年份')
      }
    },
    // 表头调整
    async headerChange(actionType = 'check') {
      try {
        this.isLoading = true;
        
        this.$message.info('正在发送整理数据命令，后端处理中...');
        // 直接发送请求到后端API，不需要前端数据
        // const csrftoken = getCookie('csrftoken');
       
        const response = await axios.post('api/headerChange/', {
          actionType: actionType,  // 传递操作类型参数
          modifyTableName: this.modifyTableName
        }, {
          // headers: {
          //   withCredentials: true,  // 启用Cookie传递
          //   'X-Csrftoken': csrftoken
          // },
          // credentials: 'include',  // 确保发送cookie
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        });
    
        if (response.data && response.data.success) {
          this.$message.success(`数据整理命令执行成功：${response.data.message}`);
        } else {
          this.$message.error('数据整理命令执行失败: ' + (response.data?.message || '未知错误'));
        }
      } catch (error) {
        console.error('发送整理数据命令失败:', error);
        this.$message.error('发送整理数据命令失败，请稍后重试');
      } finally {
        this.isLoading = false;
      }
    },
    // 没有用，暂时保留
    async planchange() {
      try {
        this.isLoading = true;
        this.$message.info('正在发送（招生计划）整理命令，后端处理中...');
        // const csrftoken = getCookie('csrftoken');

        // 直接发送请求到后端API，不需要前端数据
        const response = await axios.post('api/planchange/', {
          processAll: true,  // 处理所有数据
          updateDatabase: false  // 允许后端更新数据库
        },
        // 可选：如果需要在请求头中发送CSRF令牌
        {
          // withCredentials: true,  // 启用Cookie传递
          // headers: {'X-Csrftoken': csrftoken},
          // credentials: 'include',  // 确保发送cookie
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        },
        
      );
        
        if (response.data && response.data.success) {
          this.$message.success(`（招生计划）整理命令执行成功：${response.data.message}`);
        } else {
          this.$message.error('（招生计划）整理命令执行失败: ' + (response.data?.message || '未知错误'));
        }
      } catch (error) {
        console.error('发送（招生计划）整理命令失败:', error);
        this.$message.error('发送（招生计划）整理命令失败，请稍后重试');
      } finally {
        this.isLoading = false;
      }
    },
    // 整理原始表格数据
    async organizeCollegeData() {
      try {
        this.isLoading = true;
        this.$message.info('正在发送整理数据命令，后端处理中...');
        // const csrftoken = getCookie('csrftoken');

        // 直接发送请求到后端API，不需要前端数据
        const response = await axios.post('api/organizeCollegeData/', {
          processAll: true,  // 处理所有数据
          updateDatabase: false,  // 允许后端更新数据库
          modifyTableName:this.modifyTableName
        },
        // 可选：如果需要在请求头中发送CSRF令牌
        {
          // withCredentials: true,  // 启用Cookie传递
          // headers: {'X-Csrftoken': csrftoken},
          // credentials: 'include',  // 确保发送cookie
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        },

      );
        
        
      if (response.data && response.data.success) {
        this.$message.success(`数据整理命令执行成功：${response.data.message}`);
      } else {
        this.$message.error('数据整理命令执行失败: ' + (response.data?.message || '未知错误'));
      }
      } catch (error) {
        console.error('发送整理数据命令失败:', error);
        this.$message.error('发送整理数据命令失败，请稍后重试');
      } finally {
        this.isLoading = false;
      }
    },
    // 专业名称整理函数
    async organizeMajorNames(actionType = 'check') {
      // 根据不同操作类型显示不同提示信息
      const actionText = actionType === 'edit' ? '修改' : '检查';
      this.$message.info(`正在${actionText}列关键词，调用后端处理...`);
      
      try {
        this.isLoading = true;
        // 获取CSRF令牌
        // const csrftoken = getCookie('csrftoken');
        // 在请求体中传递操作类型参数和updateDatabase参数
        const response = await axios.post('api/organizeMajorNames/', {
          actionType: actionType,
          modifyTableName:this.modifyTableName
          // updateDatabase: actionType === 'edit' // 当actionType为'edit'时updateDatabase为true，否则为false
        }
        ,
        // 可选：如果需要在请求头中发送CSRF令牌
        {
          // withCredentials: true,  // 启用Cookie传递
          // headers: {'X-Csrftoken': csrftoken},
          // credentials: 'include',  // 确保发送cookie
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        },

      );
        
        if (response.data && response.data.success) {
          this.$message.success(`列关键词${actionText}完成`);
          // 可以选择重新加载数据或更新UI
        } else {
          this.$message.error(`列关键词${actionText}失败: ` + (response.data?.message || '未知错误'));
        }
      } catch (error) {
        console.error(`调用后端${actionText}列关键词失败:`, error);
        this.$message.error(`调用后端${actionText}列关键词失败，请检查网络连接或稍后重试`);
      } finally {
        this.isLoading = false;  // 确保无论成功失败都会重置加载状态
      }
    },
    // 检查连续相同专业
    async checkConsecutiveMajors() {
      // 先打开弹窗显示加载状态
      this.showMajorMappingDialog = true;
      this.majorMappingLoadingProgress = 0;
      this.majorMappingLoadingStatus = '正在请求数据...';
      this.consecutiveMajorGroups = []; // 清空之前的数据
      
      // 使用定时器模拟进度，让用户感觉有进展
      let simulatedProgress = 0;
      const progressInterval = setInterval(() => {
        // 缓慢增加到80%，剩下的20%留给实际下载和处理
        if (simulatedProgress < 80) {
          simulatedProgress += Math.random() * 2; // 每次增加0-2%
          this.majorMappingLoadingProgress = Math.min(Math.round(simulatedProgress), 80);
          // 根据进度显示不同状态
          if (this.majorMappingLoadingProgress < 30) {
            this.majorMappingLoadingStatus = '正在查询数据库...';
          } else if (this.majorMappingLoadingProgress < 60) {
            this.majorMappingLoadingStatus = '正在处理数据...';
          } else {
            this.majorMappingLoadingStatus = '正在准备数据...';
          }
        }
      }, 300); // 每300ms更新一次
      
      try {
        this.isLoading = true;
        
        const response = await axios.post('api/checkConsecutiveMajors/', {
          modifyTableName: this.modifyTableName
        },
        {
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
          onDownloadProgress: (progressEvent) => {
            // 清除定时器，使用真实进度
            clearInterval(progressInterval);
            if (progressEvent.total) {
              const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              // 真实进度占80%-100%
              this.majorMappingLoadingProgress = 80 + Math.round(percent * 0.2);
              this.majorMappingLoadingStatus = `正在下载数据... ${percent}%`;
            } else {
              // 如果无法获取总大小，显示已下载的数据量
              const loadedMB = (progressEvent.loaded / 1024 / 1024).toFixed(2);
              this.majorMappingLoadingStatus = `已下载 ${loadedMB} MB`;
              this.majorMappingLoadingProgress = 90;
            }
          }
        });
        
        // 请求完成，显示处理中
        clearInterval(progressInterval);
        this.majorMappingLoadingProgress = 95;
        this.majorMappingLoadingStatus = '正在处理数据...';
        
        if (response.data && response.data.success) {
          this.consecutiveMajorGroups = response.data.groups || [];
          
          // 为每个组初始化选中的招生备注
          this.consecutiveMajorGroups.forEach(group => {
            group.selectedPlanRemark = '';
            
            // 遍历每条记录，如果在mapping中，自动勾选对应的plan_remark
            group.records.forEach(record => {
              // 确保plan_remark_list存在
              if (!record.plan_remark_list) {
                record.plan_remark_list = [];
              }
              
              // 如果plan_remark_list为空但有plan_remark，创建一个默认项
              if (record.plan_remark_list.length === 0 && record.plan_remark) {
                record.plan_remark_list = [{
                  admit_year: record.admit_year,
                  batch: record.batch,
                  subject: record.subject,
                  major_group: record.major_group,
                  remark: record.plan_remark
                }];
              }
              
              // 如果在mapping中，自动勾选
              if (record.in_mapping && record.plan_remark_list.length > 0) {
                // 找到与record.plan_remark匹配的那一项（优先匹配remark，再匹配年份和批次）
                let matchedItem = null;
                
                // 第一步：尝试完全匹配（remark + admit_year + batch）
                matchedItem = record.plan_remark_list.find(item => 
                  item.remark === record.plan_remark &&
                  item.admit_year === record.admit_year &&
                  item.batch === record.batch
                );
                
                // 第二步：如果只匹配remark
                if (!matchedItem) {
                  matchedItem = record.plan_remark_list.find(item => 
                    item.remark === record.plan_remark
                  );
                }
                
                // 第三步：如果plan_remark为空，匹配空remark的项
                if (!matchedItem && (!record.plan_remark || record.plan_remark === '')) {
                  matchedItem = record.plan_remark_list.find(item => 
                    !item.remark || item.remark === ''
                  );
                }
                
                // 初始化选中项数组
                this.$set(record, 'selected_plan_items', []);
                
                if (matchedItem) {
                  // 自动勾选并设置selected_plan_items
                  record.selected_plan_items.push(matchedItem);
                  this.$set(record, 'selected_plan_item', matchedItem);
                  this.$set(record, 'selected_plan_remark', matchedItem.remark || '');
                  this.$set(record, 'is_confirmed', true);
                } else if (record.plan_remark_list.length > 0) {
                  // 如果没找到匹配项，默认选中第一项
                  record.selected_plan_items.push(record.plan_remark_list[0]);
                  this.$set(record, 'selected_plan_item', record.plan_remark_list[0]);
                  this.$set(record, 'selected_plan_remark', record.plan_remark_list[0].remark || '');
                  this.$set(record, 'is_confirmed', true);
                }
              }
            });
            
            // 在处理完 in_mapping 自动勾选后，再计算该组是否备注不全
            // 如果已经手动确认过，则不显示备注不全
            if (group._manualConfirmedComplete) {
              this.$set(group, '_incompletePlanRemark', false);
            } else {
              this.$set(group, '_incompletePlanRemark', this.hasGroupIncompletePlanRemarks(group));
            }
          });
          this.majorMappingCurrentPage = 1;  // 重置页码
          this.majorMappingLoadingProgress = 100;
          this.majorMappingLoadingStatus = '数据处理完成';
          
          // 自动匹配没有in_mapping的记录
          this.$nextTick(() => {
            this.autoMatchMajorRemarks();
          });
          
          // 延迟隐藏进度条，让用户看到完成状态
          setTimeout(() => {
            this.majorMappingLoadingProgress = 0;
            this.majorMappingLoadingStatus = '';
          }, 1000);
        } else {
          this.$message.error('检查连续相同专业失败: ' + (response.data?.message || '未知错误'));
          this.majorMappingLoadingStatus = '加载失败';
          setTimeout(() => {
            this.showMajorMappingDialog = false;
            this.majorMappingLoadingProgress = 0;
            this.majorMappingLoadingStatus = '';
          }, 1500);
        }
      } catch (error) {
        console.error('调用后端检查连续相同专业失败:', error);
        this.$message.error('调用后端检查连续相同专业失败，请检查网络连接或稍后重试');
        this.majorMappingLoadingStatus = '加载失败';
        // 出错时关闭弹窗
        setTimeout(() => {
          this.showMajorMappingDialog = false;
          this.majorMappingLoadingProgress = 0;
          this.majorMappingLoadingStatus = '';
        }, 1500);
      } finally {
        this.isLoading = false;
      }
    },

    // 修改专业组投档线（网络版）
    async modifyMajorGroupCutoff() {
      try {
        this.isLoading = true;
        this.$message.info('正在处理专业组投档线，后端处理中...');

        const response = await axios.post('api/modifyMajorGroupCutoff/', {
          origin: (this.formData && this.formData.origin) || '江苏'
        }, {
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        });

        if (response.data && response.data.success) {
          this.$message.success(response.data.message || '修改专业组投档线完成');
        } else {
          this.$message.error('修改专业组投档线失败: ' + (response.data?.message || '未知错误'));
        }
      } catch (error) {
        console.error('发送修改专业组投档线命令失败:', error);
        this.$message.error('发送修改专业组投档线命令失败，请稍后重试');
      } finally {
        this.isLoading = false;
      }
    },

    // 保存所有关联（所有页的数据，不覆盖in_mapping中已有的）
    async selectAllMajorMappingsConfirm() {
      try {
        const mappings = [];
        let skippedCount = 0;
        let inMappingCount = 0;
        let notConfirmedCount = 0;
        
        // 遍历所有分组和记录（所有页）
        for (const group of this.consecutiveMajorGroups) {
          for (const record of group.records) {
            // 跳过已经在mapping中的记录（in_mapping为true的）
            if (record.in_mapping) {
              skippedCount++;
              inMappingCount++;
              continue;
            }
            
            // 只保存已确认的记录
            if (record.is_confirmed) {
              // 使用招生计划备注（允许为空）
              const planRemark = record.selected_plan_remark || record.plan_remark || '';
              mappings.push({
                school_name: record.school_name,
                major_name: record.major_name,
                origin: record.origin,
                batch: record.batch,
                subject: record.subject,
                admit_year: record.admit_year,
                original_remark: record.remark || '',
                plan_remark: planRemark,
                is_confirmed: true
              });
            } else {
              notConfirmedCount++;
            }
          }
        }
        
        if (mappings.length === 0) {
          this.$message.warning(`没有需要保存的映射关系：${inMappingCount}条已在mapping中，${notConfirmedCount}条未勾选确认`);
          return;
        }
        
        this.isLoading = true;
        const response = await axios.post('api/saveMajorRemarkMapping/', {
          mappings: mappings
        },
        {
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        });
        
        if (response.data && response.data.success) {
          // 统计保存了多少组（按学校+专业分组）
          const savedGroups = new Set();
          mappings.forEach(m => {
            savedGroups.add(`${m.school_name}-${m.major_name}`);
          });
          this.$message.success(`已保存 ${savedGroups.size} 组关联关系（跳过 ${skippedCount} 条已有映射的记录）`);
        } else {
          this.$message.error('保存映射关系失败: ' + (response.data?.message || '未知错误'));
        }
      } catch (error) {
        console.error('保存映射关系失败:', error);
        this.$message.error('保存映射关系失败，请检查网络连接或稍后重试');
      } finally {
        this.isLoading = false;
      }
    },
    
    // 跳转到指定页并滚动到顶部
    goToMajorMappingPage(page) {
      this.majorMappingCurrentPage = page;
      this.scrollToMajorMappingTop();
    },
    
    // 滚动到专业关联弹窗顶部
    scrollToMajorMappingTop() {
      this.$nextTick(() => {
        const modalContent = this.$refs.majorMappingModalContent;
        if (modalContent) {
          modalContent.scrollTop = 0;
        }
      });
    },
    
    // 保存专业映射关系（只保存当前页，使用筛选后的数据）
    async saveMajorMappings() {
      try {
        const mappings = [];
        
        // 遍历当前页分组和记录（使用筛选后的数据）
        const currentPageGroups = this.paginatedFilteredMajorGroups || this.paginatedMajorGroups;
        for (const group of currentPageGroups) {
          for (const record of group.records) {
            if (record.is_confirmed) {
              // 使用招生计划备注（允许为空）
              const planRemark = record.selected_plan_remark || record.plan_remark || '';
              mappings.push({
                school_name: record.school_name,
                major_name: record.major_name,
                origin: record.origin,
                batch: record.batch,
                subject: record.subject,
                admit_year: record.admit_year,
                original_remark: record.remark || '',
                plan_remark: planRemark,
                is_confirmed: true
              });
            }
          }
        }
        
        if (mappings.length === 0) {
          this.$message.warning('没有需要保存的映射关系，请先勾选确认');
          return;
        }
        
        this.isLoading = true;
        const response = await axios.post('api/saveMajorRemarkMapping/', {
          mappings: mappings
        },
        {
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        });
        
        if (response.data && response.data.success) {
          this.$message.success(response.data.message || '保存成功');
        } else {
          this.$message.error('保存映射关系失败: ' + (response.data?.message || '未知错误'));
        }
      } catch (error) {
        console.error('保存映射关系失败:', error);
        this.$message.error('保存映射关系失败，请检查网络连接或稍后重试');
      } finally {
        this.isLoading = false;
      }
    },
    // 获取唯一行键
    getUniqueRowKey(row) {
      // 如果有id，优先使用，但添加额外标识防止重复
      if (row.id) return `${row.id}_${Math.floor(Math.random() * 10000)}`;
      
      // 为每一行创建一个唯一标识符，基于多个属性和随机数
      const props = ['schoolName', 'province', 'professionalName', 'admit_year', 'score'];
      let keyBase = '';
      
      // 尝试获取行数据中的多个属性
      for (const prop of props) {
        if (row[prop]) {
          keyBase += row[prop].toString();
        }
      }
      
      // 添加时间戳和随机数，确保绝对唯一
      const timestamp = Date.now();
      const random = Math.random().toString(36).substr(2, 9);
      
      // 如果基础key为空，使用一个完全随机的值
      if (!keyBase) {
        return `random_${timestamp}_${random}`;
      }
      
      return `${keyBase}_${timestamp}_${random}`;
    },
    // 合并 getRowClassName 和 samecolor 函数的逻辑
  // getCombinedRowClassName({ row, rowIndex }) {
  //   // 首先获取 getRowClassName 函数的结果
  //   const className1 = this.getRowClassName({ row, rowIndex });
    
  //   // 然后获取 samecolor 函数的结果
  //   const className2 = this.samecolor({ row, rowIndex });
    
  //   // 返回合并后的类名，用空格分隔
  //   return [className1, className2].filter(Boolean).join(' ');
  // },
  //   samecolor({ row }) {
  //     // 定义颜色类名数组
  //     const colorClasses = ['color-1', 'color-2', 'color-3', 'color-4', 'color-5'];
      
  //     // 获取学校名称和专业组信息（根据实际数据结构调整字段名）
  //     const currentSchool = row.school_name || row.学校名称 || '';
  //     const currentMajorGroup = row.major_group || row.专业组 || '';
      
  //     // 保存当前行信息供下一行比较
  //     this.previousRowInfo = this.previousRowInfo || { school: '', majorGroup: '', colorIndex: 0 };
      
  //     // 比较当前行与上一行的学校和专业组
  //     if (currentSchool === this.previousRowInfo.school && currentMajorGroup === this.previousRowInfo.majorGroup) {
  //       // 如果相同，使用与上一行相同的颜色
  //       return colorClasses[this.previousRowInfo.colorIndex];
  //     } else {
  //       // 如果不同，切换到下一个颜色
  //       this.previousRowInfo.colorIndex = (this.previousRowInfo.colorIndex + 1) % colorClasses.length;
  //       this.previousRowInfo.school = currentSchool;
  //       this.previousRowInfo.majorGroup = currentMajorGroup;
  //       return colorClasses[this.previousRowInfo.colorIndex];
  //     }
  //   },
    // 获取行类名方法，为同一学校同一专业组分配相同颜色
    getRowClassName({ row, rowIndex }) {
      const isSelected = this.selectedIndices && this.selectedIndices.includes(rowIndex);

      // 原有逻辑：检查冲稳保类型，添加risk作为可能的字段名
      const riskLevelFields = ['risk', 'riskLevel', '冲稳保', '类型', 'risk_type', '冲稳保类型'];
      
      let riskLevel = '';
      
      // 遍历可能的字段名称查找冲稳保值
      for (const field of riskLevelFields) {
        if (row[field]) {
          riskLevel = row[field].toString().trim();
          break;
        }
      }
      
      // 根据冲稳保类型确定样式类名（支持"冲"、"冲（筛）"等格式）
      let baseClass = '';
      if (riskLevel.includes('冲')) {
        baseClass = 'risk-high';
      } else if (riskLevel.includes('稳')) {
        baseClass = 'risk-medium';
      } else if (riskLevel.includes('保')) {
        baseClass = 'risk-low';
      } else {
        // 原有年份高亮逻辑
        const yearFields = ['admit_year', 'year', '入学年份'];
        let maxYear = 0;
        let rowYear = 0;
        
        for (const field of yearFields) {
          if (row[field]) {
            const year = parseInt(row[field], 10);
            if (!isNaN(year)) {
              rowYear = year;
              break;
            }
          }
        }
        
        if (rowYear === 0) {
          for (const key in row) {
            if (Object.prototype.hasOwnProperty.call(row, key)) {
              const value = row[key];
              if (typeof value === 'number' || !isNaN(parseInt(value, 10))) {
                const numValue = parseInt(value, 10);
                if (!isNaN(numValue) && numValue > 1900 && numValue < 3000) {
                  rowYear = numValue;
                  break;
                }
              }
            }
          }
        }
        
        if (this.filteredData && this.filteredData.length > 0) {
          for (const item of this.filteredData) {
            for (const field of yearFields) {
              if (item[field]) {
                const year = parseInt(item[field], 10);
                if (!isNaN(year) && year > maxYear) {
                  maxYear = year;
                }
              }
            }
          }
        }
        
        baseClass = (rowYear === maxYear || rowYear === 0) ? 'latest-year-row' : '';
      }

      // 选中行追加 table-row-selected，不替换原来的 class
      return isSelected ? (baseClass ? `${baseClass} table-row-selected` : 'table-row-selected') : baseClass;
    },
    
    // 获取单元格类名方法，为线差、位差、扩缩招列的负值添加红色样式，为专业组列添加背景色
    getCellClassName({ row, column }) {
      // 获取列的字段名（ prop）
      const property = column.property;
      
      // 检查是否是目标列（线差、位差、扩缩招）
      const targetFields = ['scr_gas', 'rnk_gas', 'scale_change', '线差', '位差', '扩缩招'];
      
      if (targetFields.includes(property)) {
        const value = row[property];
        
        // 检查值是否为负数
        if (value !== null && value !== undefined && value !== '') {
          const numValue = parseFloat(value);
          if (!isNaN(numValue) && numValue < 0) {
            return 'negative-value';
          }
        }
      }
      
      // 专业组列背景色：同一学校同一专业组一种颜色，同一学校不同专业组切换颜色
      const majorGroupFields = ['major_group', '专业组'];
      if (majorGroupFields.includes(property)) {
        // 调试日志
        // console.log('专业组列:', property, '行数据:', row);
        
        // 尝试多种可能的学校名字段名
        const schoolName = row.school_name || row.schoolName || row['学校名'] || '';
        const majorGroup = row[property] || '';
        
        // 调试：检查是否获取到学校名和专业组
        // console.log('学校名:', schoolName, '专业组:', majorGroup);
        
        if (schoolName && majorGroup) {
          // 初始化状态 - 确保每次表格渲染时重置状态
          if (this._prevSchool === undefined || this._resetMajorGroupState) {
            this._prevSchool = '';
            this._prevMajorGroup = '';
            this._currentColorIndex = 0;
            this._resetMajorGroupState = false;
            // console.log('初始化专业组状态');
          }
          
          // 检查学校是否改变
          if (schoolName !== this._prevSchool) {
            // 学校改变，切换颜色
            this._currentColorIndex = 1 - this._currentColorIndex;
            this._prevSchool = schoolName;
            this._prevMajorGroup = majorGroup;
            // console.log('学校改变:', schoolName, '颜色索引:', this._currentColorIndex);
          }
          // 学校相同但专业组改变
          else if (majorGroup !== this._prevMajorGroup) {
            // 专业组改变，切换颜色
            this._currentColorIndex = 1 - this._currentColorIndex;
            this._prevMajorGroup = majorGroup;
            // console.log('专业组改变:', majorGroup, '颜色索引:', this._currentColorIndex);
          }
          // 学校和专业组都相同，颜色保持不变
          // console.log('返回类名:', 'major-group-bg-' + this._currentColorIndex);
          
          return 'major-group-bg-' + this._currentColorIndex;
        }
      }
      
      return '';
    },
    
    // 简单哈希函数
    simpleHash(str) {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = ((hash << 5) - hash) + str.charCodeAt(i);
        hash = hash & hash;
      }
      return Math.abs(hash);
    },
    
    // 获取模拟or正式状态
    async fetchMockOrOfficialStatus() {
      try {
        const response = await axios.get('api/fetch-mock-or-official/');
        if (response.data && response.data.type) {
          this.mockOrOfficial = response.data.type;
        } else {
          this.mockOrOfficial = '模拟填报';
        }
      } catch (error) {
        console.error('获取模拟/正式状态失败:', error);
        this.mockOrOfficial = '模拟填报';
      }
     
    },
    
    // 获取筛选数据
    async fetchCollegeAdmission() {
      // 检查筛选权限
      const canFilter = await this.checkFilterPermission();
      if (!canFilter) {
        return; // 无权限，直接返回
      }

      // 记录开始时间
      this.startTime = new Date();
      this.isLoading = true;
      // this.currentPage = 1; // 重置页码

      // 重置专业组颜色状态，确保每次数据加载都从新开始
      this._resetMajorGroupState = true;
      this._prevSchool = undefined;
      this._prevMajorGroup = undefined;
      this._currentColorIndex = 0;

      // 当pageSize为'all'时禁用分页加载
      if (this.pageSize === 'all') {
        this.hasMoreData = false; // 设置为false以禁用loadMoreData
      } else {
        this.hasMoreData = true; // 重置是否有更多数据
      }

      try {
        // const csrftoken = getCookie('csrftoken');

        // 当pageSize为'all'时，使用一个足够大的数值来获取所有数据
        const actualPageSize = this.pageSize === 'all' ? 100000 : this.pageSize;

        // 构建 formData，如果从院校库跳转则跳过位次筛选
        const requestFormData = { ...this.formData }
        if (this._skipRankFilterFromSchool) {
          requestFormData.skip_rank_filter = true
        }

        // 调试日志
        // console.log('=== fetchCollegeAdmission 请求数据 ===')
        // console.log('formData:', JSON.stringify(requestFormData, null, 2))
        // console.log('professionalRows:', JSON.stringify(this.professionalRows, null, 2))
        // console.log('skip_rank_filter:', this._skipRankFilterFromSchool)

        const response = await axios.post('api/fetchCollegeAdmission/', {
          formData: requestFormData,
          professionalRows: this.professionalRows,
          page: this.currentPage,
          page_size: actualPageSize
        },
        // 可选：如果需要在请求头中发送CSRF令牌
        {
          // withCredentials: true,  // 启用Cookie传递
          // headers: {'X-Csrftoken': csrftoken},
          // credentials: 'include',  // 确保发送cookie
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        });
        
        // 确保返回的是数组格式
        let responseData = response.data;
        
        // 获取并保存总条数
        this.schoolCount = response.data.count || 0;
        this.allSchools = response.data.schools;
        
        if (!Array.isArray(responseData)) {
          // 检查是否是分页响应对象
          if (responseData.results) {
            responseData = responseData.results;
          } else if (responseData.data) {
            responseData = responseData.data;
          } else {
            responseData = [responseData];
          }
        }
        
        if (responseData.length === 0) {
          // 检查是否是从院校库跳转过来的查询
          const hasSchoolName = this.professionalRows && 
                                 this.professionalRows.some(row => row.schoolName && row.schoolName.trim());
          if (hasSchoolName) {
            this.$message.warning('没有找到该学校的志愿数据，请检查：\n1. 学校名称是否正确\n2. 筛选条件（省份、科目、批次）是否匹配');
          } else {
            this.$message.warning('没有找到匹配的志愿数据，请调整筛选条件');
          }
          this.isLoading = false;
          return;
        }
        
        this.filteredData = responseData;
        
        // 优化：使用setTimeout确保DOM更新队列完成
        setTimeout(() => {
          // 计算数据加载时间（API请求时间）
          this.endTime = new Date();
          const loadTime = ((this.endTime - this.startTime) / 1000).toFixed(2);
          
          // 显示加载完成消息
          this.$message.success(`筛选完成，共 ${this.schoolCount} 所学校，耗时 ${loadTime} 秒`);
          
          // 滚动到筛选表标题位置（仅小屏）
          this.$nextTick(() => {
            // 延迟确保DOM已渲染
            setTimeout(() => {
              // 判断是否小屏（宽度小于768px）
              const isSmallScreen = window.innerWidth < 768
              if (isSmallScreen) {
                // 滚动到筛选表标题
                const titleEl = this.$refs.filteredTableTitle
                if (titleEl) {
                  titleEl.scrollIntoView({ behavior: 'smooth', block: 'start' })
                }
              }
              // 滚动表格内部到顶部
              const tableBody = document.querySelector('.custom-table .el-table__body-wrapper');
              if (tableBody) {
                tableBody.scrollTop = 0;
              }
            }, 500)
          });

          // 延迟关闭加载状态
          setTimeout(() => {
            this.isLoading = false;
          }, 300);
        }, 200);
          
      } catch (error) {
        console.error('请求出错:', error);
        this.$message.error(error.response?.data?.message || error.message || '请求失败，请稍后重试');
        this.isLoading = false;
      }
    },
    
    // 分数更改后位次和同位分人数自动更新
    async fetchRankData() {
      // console.log('>>> fetchRankData 开始执行');
      try {
        // 检查 this 上下文
        // console.log('fetchRankData this.formData:', this.formData ? '存在' : '不存在');
        // console.log('fetchRankData formData.scr_line:', this.formData?.scr_line);
        
        // console.log('fetchRankData 请求参数:', {
        //   batch: this.formData?.batch,
        //   admit_year: this.formData?.admit_year,
        //   origin: this.formData?.origin,
        //   subject: this.formData?.subject1,
        //   scr_line: this.formData?.scr_line
        // });

        // 添加随机数防止微信浏览器缓存
        const randomStr = Math.random().toString(36).substring(7);
        
        // 获取 CSRF token
        const csrftoken = document.cookie.match(/csrftoken=([^;]+)/)?.[1];
        // console.log('CSRF token:', csrftoken ? '存在' : '不存在');
        
        const response = await axios.post(`api/fetch-rank-data/?_wx=${randomStr}`, {
          batch: this.formData.batch,
          admit_year: this.formData.admit_year,
          origin: this.formData.origin,
          subject: this.formData.subject1,
          scr_line: this.formData.scr_line,
        }, {
          headers: csrftoken ? { 'X-Csrftoken': csrftoken } : {}
        });
        
        // console.log('fetchRankData 响应:', response.data);
        
        // 保存响应数据
        const admissionRank = response.data.admission_rank;
        const sameRankScore = response.data.same_rank_score;
        
        // 使用 Vue.set 确保响应式更新
        this.$set(this.formData, 'admission_rank', admissionRank);
        this.$set(this.formData, 'same_rank_score', sameRankScore);
        
        // 强制更新视图（针对微信浏览器）
        this.$forceUpdate();
        
        // 使用 nextTick 确保 DOM 更新后再执行一次更新（微信浏览器兼容）
        this.$nextTick(() => {
          // 再次确认值已设置
          if (this.formData.admission_rank !== admissionRank) {
            console.log('nextTick 修复位次:', this.formData.admission_rank, '->', admissionRank);
            this.formData.admission_rank = admissionRank;
            this.formData.same_rank_score = sameRankScore;
          }
          // console.log('nextTick 后位次:', this.formData.admission_rank);
        });
        
        // 微信浏览器特殊处理：延迟再次更新
        setTimeout(() => {
          if (this.formData.admission_rank !== admissionRank) {
            console.log('setTimeout 修复位次:', this.formData.admission_rank, '->', admissionRank);
            this.$set(this.formData, 'admission_rank', admissionRank);
            this.$set(this.formData, 'same_rank_score', sameRankScore);
          }
        }, 100);
      } catch (error) {
        console.error('获取位次数据失败:', error);
        console.error('错误详情:', error.response?.data || error.message);
        // 如果没有数据，静默处理，不显示错误提示
        if (error.response?.data?.message === '没有数据') {
          this.$set(this.formData, 'admission_rank', null);
          this.$set(this.formData, 'same_rank_score', null);
        }
      }
    },
    
    // 提交搜索表单
    async submitSearchForm() {
      try {
        // const csrftoken = getCookie('csrftoken');
        const response = await axios.post('api/search/', {
          formData: this.formData,
          professionalRows: this.professionalRows
        },
        // 可选：如果需要在请求头中发送CSRF令牌
        {
          // withCredentials: true,  // 启用Cookie传递
          // headers: {'X-Csrftoken': csrftoken},
          // credentials: 'include',  // 确保发送cookie
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        });
        this.filteredData = response.data
      } catch (error) {
        console.error('提交失败:', error)
      }
    },
    
    // 生成表格行
    generateTableRows(count) {
      for (let i = 0; i < count; i++) {
        this.professionalRows.push({
          professional: '',
          tag: '',
          schoolName: '',
          schoolProvince: '',
          schoolType: '',
          professionalRemark: ''
        })
      }
      // 添加背景色类以区分不同组
      this.$nextTick(() => {
        this.updateRowBackgrounds()
      })
    },

    // 更新行背景色
    updateRowBackgrounds() {
      // console.log('updateRowBackgrounds called')
      // 只选择数据行（tbody中的tr），排除表头
      const tables = document.querySelectorAll('.professional-table')
      // console.log('Found tables:', tables.length)
      
      tables.forEach(table => {
        const dataRows = table.querySelectorAll('tbody tr')
        // console.log('Found data rows:', dataRows.length)
        
        dataRows.forEach((row, index) => {
          // 每个专业条件（每行）作为一个组，交替背景色
          const groupIndex = Math.floor(index)  // 每行就是一个专业条件
          // 组索引为偶数时显示浅蓝色，奇数时显示浅黄色（区分度更大）
          if (groupIndex % 2 === 0) {
            // 使用更强制性的方式设置背景色
            row.style.cssText += 'background-color: #d4edff !important;' // 浅蓝色（比原来更明显）
          } else {
            row.style.cssText += 'background-color: #fff8e1 !important;' // 浅黄色（对比度更高）
          }
          // console.log(`专业条件 ${index + 1}: 颜色组 ${groupIndex % 2 === 0 ? '浅蓝' : '浅黄'}`)
        })
      })
    },
    
    // 移除最后一行
    removeLastRow() {
      if (this.professionalRows.length > 0) {
        this.professionalRows.pop()
        // 更新背景色
        this.$nextTick(() => {
          this.updateRowBackgrounds()
        })
      }
    },
    // 添加检查年份并显示确认对话框的方法
    checkYearAndConfirmAdd(row) {
      // 找出当前数据集的最大年份
      const yearFields = ['admit_year', 'year', '入学年份'];
      let maxYear = 0;
      
      if (this.filteredData && this.filteredData.length > 0) {
        for (const item of this.filteredData) {
          for (const field of yearFields) {
            if (item[field]) {
              const year = parseInt(item[field], 10);
              if (!isNaN(year) && year > maxYear) {
                maxYear = year;
              }
            }
          }
        }
      }
      
      // 获取当前行的年份
      let rowYear = 0;
      for (const field of yearFields) {
        if (row[field]) {
          const year = parseInt(row[field], 10);
          if (!isNaN(year)) {
            rowYear = year;
            break;
          }
        }
      }
      
      // 如果没找到标准年份字段，尝试遍历整个对象查找合理范围内的数字值（可能是年份）
      if (rowYear === 0) {
        for (const key in row) {
          if (Object.prototype.hasOwnProperty.call(row, key)) {
            const value = row[key];
            if (typeof value === 'number' || !isNaN(parseInt(value, 10))) {
              const numValue = parseInt(value, 10);
              if (!isNaN(numValue) && numValue > 1900 && numValue < 3000) {
                rowYear = numValue;
                break;
              }
            }
          }
        }
      }
      
      // 判断是否为最新年份
      if (rowYear < maxYear && maxYear > 0) {
        // 不是最新年份，显示确认对话框
        this.$confirm(`该数据年份为${rowYear}年，不是最新年份(${maxYear}年)，确定要添加到志愿表吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 用户确认添加
          this.addToWishList(row);
        }).catch(() => {
          // 用户取消添加
          this.$message({
            type: 'info',
            message: '已取消添加'
          });
        });
      } else {
        // 是最新年份，直接添加
        this.addToWishList(row);
      }
    },
    // 获得列名注释
    formatColumnName(key) {
      // 本地字段名映射（用于关联的原始数据字段）
      const localColumnMap = {
        'org_h_scr': '原始最高分',
        'org_h_rnk': '原始最高位次',
        'org_l_scr': '原始最低分',
        'org_l_rnk': '原始最低位次',
        'org_plan': '原始计划数',
        'org_pre_pl': '原始往年数',
        'org_rnk_gas': '原始位差',
        'org_remark': '原始备注',
        '_has_org_data_': '有原始数据',
        '_has_confirmed_mapping_': '已确认映射'
      };
      
      // 优先使用本地映射
      if (localColumnMap[key]) {
        return localColumnMap[key];
      }
      
      // 确保columnComments已加载且包含当前key
      // console.log('当前列名:', key, '可用注释:', this.columnComments);
      if (!this.columnComments || !this.columnComments[key]) {
        // 如果没有找到注释，返回原始键名
        return key;
      }
      return this.columnComments[key];
    },
      
   
  }
}
